import { createAsyncThunk } from '@/redux/createAsyncThunk';
import { getAuthToken } from '@/redux/modules/user';
import { getDeployment } from '@/redux/modules/config';
import {
    postReceivedPayment,
    PostReceivedPaymentResponsePayload,
} from '@/redux/modules/billingManagement/receivedPayment/receivedPayment.api';
import { ReceivedPayment } from '@/redux/modules/billingManagement/receivedPayment/receivedPayment.types';

type SaveReceivedPaymentParams = {
    houseId: number;
    receivedPayment: ReceivedPayment;
};

export const saveReceivedPayment = createAsyncThunk<PostReceivedPaymentResponsePayload, SaveReceivedPaymentParams>(
    'la/ui/receivedPayment/saveReceivedPayment',
    async (params, { getState }) => {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        const { payload } = await postReceivedPayment({
            ...params,
            authToken,
            deployment,
        });
        return payload;
    }
);
